export const fallbackValue = true;

export const propertyKey = 'gic-jsm-fields-layout-preference';

export const UserPreference = {
	ScreenFields: 'SCREEN_FIELDS',
	RequestFormFields: 'REQUEST_FORM_FIELDS',
} as const;
export type UserPreference = (typeof UserPreference)[keyof typeof UserPreference];
